import { FightPlayer, Spell } from 'web/data/models'
import { CooldownResolver, DecoratingCooldownResolver } from 'web/engine/cooldowns/core-resolver'
import { GENERATED_IDS } from './generated-ids'

type SpellResolverMap = { [spellId: string]: CooldownResolver }

const { __SPELL_ID, __TALENT_ID, __MODIFIER_ID } = GENERATED_IDS

const dkResolvers: SpellResolverMap = {
    [__SPELL_ID.DK.BLOOD.AMZ]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DK.BLOOD.ASSIMILATION)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    },
    [__SPELL_ID.DK.BLOOD.GRASP]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DK.BLOOD.TIGHT_GRASP)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    },
    [__SPELL_ID.DK.FROST.AMZ]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DK.FROST.ASSIMILATION)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    },
    [__SPELL_ID.DK.UNHOLY.AMZ]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DK.UNHOLY.ASSIMILATION)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    }
}

const druidResolvers: SpellResolverMap = {
    [__SPELL_ID.DRUID.RESTO.IRONBARK]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.RESTO.IMPR_IRONBARK)) {
            return spell.cooldown - 20
        }
        return spell.cooldown
    },
    [__SPELL_ID.DRUID.RESTO.TRANQ]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.RESTO.INNER_PEACE)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    },
    [__SPELL_ID.DRUID.BALANCE.ROAR]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.BALANCE.IMPROVED_ROAR)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    },
    [__SPELL_ID.DRUID.FERAL.ROAR]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.FERAL.IMPROVED_ROAR)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    },
    [__SPELL_ID.DRUID.GUARDIAN.ROAR]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.GUARDIAN.IMPROVED_ROAR)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    },
    [__SPELL_ID.DRUID.RESTO.ROAR]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.RESTO.IMPROVED_ROAR)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    },
    [__SPELL_ID.DRUID.RESTO.CONVOKE]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DRUID.RESTO.CEN_GUIDANCE)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    }
}

const dhResolvers: SpellResolverMap = {
    [__SPELL_ID.DH.HAVOC.DARKNESS]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DH.HAVOC.PITCH_BLACK)) {
            return spell.cooldown - 120
        }
        return spell.cooldown
    },
    [__SPELL_ID.DH.VENG.DARKNESS]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.DH.VENG.PITCH_BLACK)) {
            return spell.cooldown - 120
        }
        return spell.cooldown
    }
}

const monkResolvers: SpellResolverMap = {
    [__SPELL_ID.MONK.MW.CHI_JI]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.MW.GIFT_OF_CELEST)) {
            return spell.cooldown - 120
        }
        return spell.cooldown
    },
    [__SPELL_ID.MONK.MW.YULON]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.MW.GIFT_OF_CELEST)) {
            return spell.cooldown - 120
        }
        return spell.cooldown
    },
    [__SPELL_ID.MONK.MW.COCOON]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.MW.CHRYS)) {
            return spell.cooldown - 45
        }
        return spell.cooldown
    },

    [__SPELL_ID.MONK.MW.SWEEP]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.MW.ANCIENT_ARTS_2)) {
            return spell.cooldown - 10
        }
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.MW.ANCIENT_ARTS_1)) {
            return spell.cooldown - 5
        }

        return spell.cooldown
    },
    [__SPELL_ID.MONK.BRM.SWEEP]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.BRM.ANCIENT_ARTS_2)) {
            return spell.cooldown - 10
        }
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.BRM.ANCIENT_ARTS_1)) {
            return spell.cooldown - 5
        }

        return spell.cooldown
    },
    [__SPELL_ID.MONK.WW.SWEEP]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.WW.ANCIENT_ARTS_2)) {
            return spell.cooldown - 10
        }
        if (fightPlayer.talentIds.includes(__TALENT_ID.MONK.WW.ANCIENT_ARTS_1)) {
            return spell.cooldown - 5
        }

        return spell.cooldown
    },
}

const paladinResolvers: SpellResolverMap = {
    [__SPELL_ID.PALADIN.HOLY.AM]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.HOLY.UNWAVERING_SPIRIT)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    },
    [__SPELL_ID.PALADIN.HOLY.DIVINE_TOLL]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.HOLY.QUICK_INVO)) {
            return spell.cooldown - 15
        }
        return spell.cooldown
    },
    [__SPELL_ID.PALADIN.HOLY.BOP]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.HOLY.IMP_BLESSING)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    },
    [__SPELL_ID.PALADIN.HOLY.DIV_SHIELD]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.HOLY.UNBREAK_SPIRIT)) {
            return Math.round(spell.cooldown * 0.70)
        }
        return spell.cooldown
    },
    [__SPELL_ID.PALADIN.HOLY.BLESS_SAC]: (spell, fightPlayer) => {
        // This has changed to a 15s CDR for Holy only, other specs keep their 60s
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.HOLY.SAC_JUST)) {
            return spell.cooldown - 15
        }
        return spell.cooldown
    },
    [__SPELL_ID.PALADIN.PROT.SPELLWARDING]: (spell, fightPlayer) => {
        let cooldown = spell.cooldown
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.IMP_BLESSING)) {
            cooldown = cooldown - 60
        }
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_2_2)) {
            cooldown = Math.round(cooldown * 0.70)
        } else if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_1_2)) {
            cooldown = Math.round(cooldown * 0.85)
        }
        return cooldown
    },
    [__SPELL_ID.PALADIN.PROT.BOP]: (spell, fightPlayer) => {
        let cooldown = spell.cooldown
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.IMP_BLESSING)) {
            cooldown = cooldown - 60
        }
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_2_2)) {
            cooldown = Math.round(cooldown * 0.70)
        } else if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_1_2)) {
            cooldown = Math.round(cooldown * 0.85)
        }
        return cooldown
    },
    [__SPELL_ID.PALADIN.PROT.DIV_SHIELD]: (spell, fightPlayer) => {
        let cooldown = spell.cooldown
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_2_2)) {
            cooldown = Math.round(cooldown * 0.70)
        } else if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.COUNSEL_1_2)) {
            cooldown = Math.round(cooldown * 0.85)
        }
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.UNBREAK_SPIRIT)) {
            cooldown = Math.round(cooldown * 0.70)
        }
        return cooldown
    },
    [__SPELL_ID.PALADIN.PROT.BLESS_SAC]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.PROT.SAC_JUST)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    },
    [__SPELL_ID.PALADIN.RET.BOP]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.RET.IMP_BLESSING)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    },
    [__SPELL_ID.PALADIN.RET.DIV_SHIELD]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.RET.UNBREAK_SPIRIT)) {
            return Math.round(spell.cooldown * 0.70)
        }
        return spell.cooldown
    },
    [__SPELL_ID.PALADIN.RET.BLESS_SAC]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PALADIN.RET.SAC_JUST)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    }
}

const evokerResolvers: SpellResolverMap = {
    [__SPELL_ID.EVOKER.PRES.REWIND]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.EVOKER.PRES.TEMPORAL_ARTIFICER)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    }
}

const priestResolvers: SpellResolverMap = {
    [__SPELL_ID.PRIEST.SHADOW.VAMP_EMBRACE]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PRIEST.SHADOW.SANLAYN)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    },
    [__SPELL_ID.PRIEST.SHADOW.LEAP_OF_FAITH]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PRIEST.SHADOW.MOVE_WITH_GRACE)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    },
    [__SPELL_ID.PRIEST.HOLY.GUARDIAN_SPIRIT]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PRIEST.HOLY.GUARDIAN_ANGEL)) {
            return 60
        }
        return spell.cooldown
    },
    [__SPELL_ID.PRIEST.HOLY.LEAP_OF_FAITH]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PRIEST.HOLY.MOVE_WITH_GRACE)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    },
    [__SPELL_ID.PRIEST.DISC.LEAP_OF_FAITH]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.PRIEST.DISC.MOVE_WITH_GRACE)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    }
}

const hunterResolvers: SpellResolverMap = {
    [__SPELL_ID.HUNTER.BM.TURTLE]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.HUNTER.BM.BORN_TO_BE_WILD)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    },
    [__SPELL_ID.HUNTER.SV.TURTLE]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.HUNTER.SV.BORN_TO_BE_WILD)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    },
    [__SPELL_ID.HUNTER.MM.TURTLE]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.HUNTER.MM.BORN_TO_BE_WILD)) {
            return spell.cooldown - 30
        }
        return spell.cooldown
    }
}

const shamanResolvers: SpellResolverMap = {
    [__SPELL_ID.SHAMAN.ELE.RECALL]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.ELE.CALL_OF_THE_ELEMENTS)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    },
    [__SPELL_ID.SHAMAN.ELE.WRT]: (spell, fightPlayer) => {
        let cooldown = spell.cooldown

        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.ELE.ASC_AIR)) {
            cooldown -= 30
        }
        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.ELE.TOTEMIC_SURGE)) {
            cooldown -= 6
        }
        return cooldown
    },

    [__SPELL_ID.SHAMAN.RESTO.RECALL]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.RESTO.CALL_OF_THE_ELEMENTS)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    },
    [__SPELL_ID.SHAMAN.RESTO.WRT]: (spell, fightPlayer) => {
        let cooldown = spell.cooldown

        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.RESTO.ASC_AIR)) {
            cooldown -= 30
        }
        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.RESTO.TOTEMIC_SURGE)) {
            cooldown -= 6
        }
        return cooldown
    },
    [__SPELL_ID.SHAMAN.RESTO.ASC]: (spell, fightPlayer) => {
        let cooldown = spell.cooldown

        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.RESTO.FIRST_ASCENDANT)) {
            cooldown -= 60
        }
        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.RESTO.TOTEMIC_SURGE)) {
            cooldown -= 6
        }

        return cooldown
    },
    [__SPELL_ID.SHAMAN.RESTO.HTT]: (spell, fightPlayer) => {
        let cooldown = spell.cooldown

        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.RESTO.CURRENT_CONTROL)) {
            cooldown -= 45
        }
        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.RESTO.TOTEMIC_SURGE)) {
            cooldown -= 6
        }

        return cooldown
    },
    [__SPELL_ID.SHAMAN.RESTO.SLT]: (spell, fightPlayer) => {
        let cooldown = spell.cooldown

        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.RESTO.TOTEMIC_SURGE)) {
            cooldown -= 6
        }

        return cooldown
    },
    [__SPELL_ID.SHAMAN.RESTO.MTT]: (spell, fightPlayer) => {
        let cooldown = spell.cooldown

        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.RESTO.TOTEMIC_SURGE)) {
            cooldown -= 6
        }

        return cooldown
    },

    [__SPELL_ID.SHAMAN.ENH.RECALL]: (spell, fightPlayer) => {
        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.ENH.CALL_OF_THE_ELEMENTS)) {
            return spell.cooldown - 60
        }
        return spell.cooldown
    },
    [__SPELL_ID.SHAMAN.ENH.WRT]: (spell, fightPlayer) => {
        let cooldown = spell.cooldown

        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.ENH.ASC_AIR)) {
            cooldown -= 30
        }
        if (fightPlayer.talentIds.includes(__TALENT_ID.SHAMAN.ENH.TOTEMIC_SURGE)) {
            cooldown -= 6
        }
        return cooldown
    },
}

export const SPELL_RESOLVERS: SpellResolverMap = {
    ...dkResolvers,
    ...druidResolvers,
    ...dhResolvers,
    ...monkResolvers,
    ...paladinResolvers,
    ...evokerResolvers,
    ...priestResolvers,
    ...hunterResolvers,
    ...shamanResolvers
}


export const GENERIC_RESOLVERS: { [key: string]: DecoratingCooldownResolver } = {

    /**
     * Not used, but keeping it as a reference.
     *
     * NOTICE: Trust nothing in here, I have no idea what any of this
     * is supposed to do.
     */
    VOP_R3: (spell: Spell, fightPlayer: FightPlayer, cooldown: number) => {
        const spellIsAffected = spell.affectedByModifierIds
            .includes("__MODIFIER_ID.ESSENCE_VOP")

        const playerHasMod = fightPlayer.modifierIds
            .includes("__MODIFIER_ID.ESSENCE_VOP")

        const applyMod = spellIsAffected && playerHasMod

        if (applyMod === false) {
            return cooldown
        }

        // VOP R3 takes off roughly 77% (23% reduction)
        return Math.ceil(cooldown * 0.77)
    }

}
